// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"6a1ce180","160":"6db03a79"}[chunkId] + ".chunk.js";
};